import { observer } from 'mobx-react-lite'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import GapDialog from 'reusable/gap-dialog/GapDialog'

import { useOAuthClientStore } from './OAuthClientStore'
import OAuthConfigField from './OAuthConfigField'

export default observer(function OAuthClientConfig() {
   const oAuthClientStore = useOAuthClientStore()
   const { clientConfig, isLoadingConfig, configModal } = oAuthClientStore

   return (
      <GapDialog
         modalState={configModal}
         size="medium"
         title={`OAuth Configuration: ${clientConfig?.clientId || 'Loading...'}`}
         cancel={true}
      >
         <Box>
            <Typography variant="h6" sx={{ mb: 2 }}>
               Basic Settings
            </Typography>

            <OAuthConfigField
               label="Client ID"
               value={clientConfig?.clientId || ''}
               fieldName="clientId"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="Client Secret"
               value={clientConfig?.clientSecret || ''}
               fieldName="clientSecret"
               showRegenerateButton={true}
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="Scope"
               value={clientConfig?.scope || ''}
               fieldName="scope"
               loading={isLoadingConfig}
            />

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ mb: 2 }}>
               OAuth URLs
            </Typography>

            <OAuthConfigField
               label="Authorization URL"
               value={clientConfig?.urls.authorize || ''}
               fieldName="authorizeUrl"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="Token Fetch URL"
               value={clientConfig?.urls.token || ''}
               fieldName="tokenUrl"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="Profile Info API URL"
               value={clientConfig?.urls.userinfo || ''}
               fieldName="userinfoUrl"
               loading={isLoadingConfig}
            />

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ mb: 2 }}>
               Response Paths
            </Typography>

            <OAuthConfigField
               label="User ID response path"
               value={clientConfig?.responsePaths.userId || ''}
               fieldName="userIdPath"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="User Email response path"
               value={clientConfig?.responsePaths.email || ''}
               fieldName="emailPath"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="User Name response path"
               value={clientConfig?.responsePaths.name || ''}
               fieldName="namePath"
               loading={isLoadingConfig}
            />

            <OAuthConfigField
               label="Profile image URL response path"
               value={clientConfig?.responsePaths.picture || ''}
               fieldName="picturePath"
               loading={isLoadingConfig}
            />
         </Box>
      </GapDialog>
   )
})
